import styled, { css } from 'styled-components';
import { colors, boxShadows } from '@alixpartners/ui-components';

export const Container = styled.div`
  display: inline-box;
  height: 140px;
  box-shadow: ${boxShadows[2]};
  padding: 16px 24px;
  backgrround-color: ${colors.white};
  box-sizing: content-box;
`;

export const Section = styled.div`
  width: 245px;
  &:nth-child(2) {
    padding-left: 16px;
    margin-left: -10px;
    border-left: 1px solid ${colors.grey3};
    width: 238px;
  }
`;

export const Header = styled.div`
  color: ${colors.grey5};
  font-size: 11px;
  font-weight: normal;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Column = styled.div<{ isHighlighted?: boolean }>`
  width: 50%;
  border: 1px solid transparent;
  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      font-weight: bold;
    `}
`;

export const Title = styled.div`
  font-size: 11px;
  color: ${colors.grey7};
`;

export const SecondaryDataValue = styled.div<{ fontSize?: number }>`
  font-size: ${({ fontSize }) => `${fontSize || 23}px`};
  font-weight: 500;
  line-height: 33px;
  color: ${colors.grey7};
`;

export const ValueContainer = styled.div`
  display: flex;
  margin-top: 4px;
`;
